import styled from 'styled-components';
import breakpoints from '../../../../../../../../styling/breakpoints';
import breakpointsMinWidth from '../../../../../../../../styling/breakpointsMinWidth';

export default styled.div`
  width: 303px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  .single-line {
    /* height: 21px; */
    /* display: flex; */
    align-items: center;
    white-space: nowrap;
    width: -webkit-fill-available;
    overflow: auto;
    text-align: justify;
    scrollbar-width: none;
    width: 100%;
    line-height: 24px;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    @supports (-moz-appearance: none) {
      white-space: pre;
    }
    white-space: pre;
    word-wrap: normal;
  }

  /* @media ${breakpoints.desktopLg} {
    width: 600px;
  } */
  @media ${breakpointsMinWidth.mobileMicroLg} {
    width: 350px;
  }
  @media ${breakpointsMinWidth.tabletSm} {
    width: 480px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    width: 465px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    width: 545px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    width: 712px;
  }
`;
